import { render } from "./PatientFollow.vue?vue&type=template&id=0e195f03&scoped=true"
import script from "./PatientFollow.vue?vue&type=script&lang=js"
export * from "./PatientFollow.vue?vue&type=script&lang=js"

import "./PatientFollow.vue?vue&type=style&index=0&id=0e195f03&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e195f03"]])

export default __exports__